import React from 'react';
import { Link } from 'react-router-dom';
import { useSiteData } from '../../context/SiteDataContext';
import { Phone } from 'lucide-react';

const CTASection = () => {
  const { companyInfo, pageContent } = useSiteData();
  const c = pageContent?.cta || {};

  return (
    <section className="py-16 sm:py-24 bg-neutral-950" data-testid="cta-section">
      <div className="max-w-4xl mx-auto px-4 sm:px-6 lg:px-12 text-center">
        <h2 className="text-2xl sm:text-3xl md:text-4xl lg:text-5xl font-bold text-white mb-4 sm:mb-6">
          {c.title || 'Envie de transformer'} <span className="text-red-500">{c.titleAccent || 'votre véhicule ?'}</span>
        </h2>
        <p className="text-white/60 text-sm sm:text-base lg:text-lg mb-8 sm:mb-10 max-w-2xl mx-auto">
          {c.desc || 'Contactez-nous dès maintenant pour discuter de votre projet ou prendre rendez-vous'}
        </p>
        <div className="flex flex-col sm:flex-row gap-3 sm:gap-4 justify-center">
          <Link to="/contact" data-testid="cta-contact" className="group inline-flex items-center justify-center gap-3 bg-red-600 hover:bg-red-700 text-white px-6 sm:px-8 py-3 sm:py-4 rounded-full font-medium transition-all duration-300 text-sm sm:text-base">
            <span>Contact & Rendez-vous</span>
            <svg className="w-4 h-4 sm:w-5 sm:h-5 group-hover:translate-x-1 transition-transform" fill="none" viewBox="0 0 24 24" stroke="currentColor"><path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M17 8l4 4m0 0l-4 4m4-4H3" /></svg>
          </Link>
          <a href={`tel:${companyInfo.phone.replace(/\s/g, '')}`} data-testid="cta-phone" className="inline-flex items-center justify-center gap-3 bg-white/10 hover:bg-white/20 backdrop-blur-sm text-white px-6 sm:px-8 py-3 sm:py-4 rounded-full font-medium border border-white/20 transition-all duration-300 text-sm sm:text-base">
            <Phone size={18} />
            <span>{companyInfo.phone}</span>
          </a>
        </div>
      </div>
    </section>
  );
};

export default CTASection;
